import { Comparator, Color, DisplayType, EndgameContent, MinimapIconShape, MinimapIconSize, Rarity } from '../../models/enums';
import { CustomRule } from '../../models/filter-models';
import { poe2 } from '../../../game';

export interface EndgamePresetCustomRuleDef {
  content: EndgameContent;
  description: string;
  cosmetic: boolean;
  rule: Partial<CustomRule>;
}

export const ENDGAME_PRESET_CUSTOM_RULES: EndgamePresetCustomRuleDef[] = poe2 ? [
  {
    content: EndgameContent.Abyss,
    description: 'Shows Omens of the Liege and plays an alert sound, so you know when you missed the Amanamu monster.',
    cosmetic: true,
    rule: {
      itemClass: 'Omen',
      itemType: 'Omens',
      baseTypes: ['Omen of the Liege'],
      rarityComparator: Comparator.GreaterThanOrEqual,
      rarity: Rarity.Normal,
      continue: false,
      displayOptions: {
        active: true,
        hidden: false,
        displayType: DisplayType.Custom,
        cosmeticOptions: {
          backgroundColor: '#000000aa',
          alertSound: true,
          alertSoundSound: '14',
          alertSoundVolume: 200,
          highlight: false,
          beam: true,
          highlightColor: Color.White,
          minimapIconSize: MinimapIconSize.Small,
          minimapIconShape: MinimapIconShape.Circle,
          fontSize: 21,
        },
      },
    },
  },
] : [];
